// Footer.jsx - Reusable footer component for all customer-facing screens
import React, { useState } from 'react';
import { ZINDEX, FONT_SIZE } from '@/core/platform/platformStandards';
import PropTypes from 'prop-types';
import { Box, Typography, Container, Link, useTheme } from '@mui/material';
import ViewTermsModal from '@/features/auth/components/ViewTermsModal';

const Footer = ({
  backgroundColor,
  textColor,
  borderTop = true
}) => {
  const theme = useTheme();
  const [modalType, setModalType] = useState(null);

  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { text: 'Terms of Service', type: 'terms' },
    { text: 'Privacy Policy', type: 'privacy' }
  ];

  return (
    <>
      <Box
        component="footer"
        sx={{
          backgroundColor: backgroundColor || theme.palette.background.paper,
          borderTop: borderTop ? `1px solid ${theme.palette.custom.borders.subtle}` : 'none',
          py: theme.spacing(0.0625), // 0.0625 * 8px = 0.5px
          px: { xs: 2, sm: 3 },
          mt: 'auto', // Push to bottom
          position: 'relative',
          zIndex: ZINDEX.stickyContent
        }}
      >
        <Container maxWidth="xl" sx={{ py: 0, px: 0 }}>
          <Box sx={{ textAlign: 'center', py: 0, my: 0 }}>
            <Typography
              variant="body2"
              sx={{
                color: textColor || theme.palette.text.secondary,
                fontSize: FONT_SIZE.xs,
                fontWeight: 400,
                margin: 0,
                padding: 0
              }}
            >
              © {currentYear} HFRConnect. All rights reserved. |
              {footerLinks.map((link, index) => (
                <React.Fragment key={link.type}>
                  <Link
                    href="#"
                    onClick={(e) => { e.preventDefault(); setModalType(link.type); }}
                    sx={{
                      color: textColor || theme.palette.text.secondary,
                      textDecoration: 'none',
                      fontSize: FONT_SIZE.xs,
                      fontWeight: 400,
                      '&:hover': {
                        color: theme.palette.primary.main,
                        textDecoration: 'none'
                      }
                    }}
                  >
                    {link.text}
                  </Link>
                  {index < footerLinks.length - 1 && ' | '}
                </React.Fragment>
              ))}
            </Typography>
          </Box>
        </Container>
      </Box>

      <ViewTermsModal
        open={modalType !== null}
        type={modalType || 'terms'}
        onClose={() => setModalType(null)}
      />
    </>
  );
};

Footer.propTypes = {
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  borderTop: PropTypes.bool
};

export default Footer;
